import CompanyActionThemeScope from 'src/theme/CompanyActionThemeScope';
import useCompanyActionConfiguration from 'src/theme/useCompanyActionConfiguration';
import { JobPublicationApprovalPrompt } from 'src/components/JobPublication';
import { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';
import { ToastContainer } from 'react-toastify';
import RouteErrorBoundary from 'src/components/RouteErrorBoundary';

interface SidebarLayoutProps {
  children?: ReactNode;
}
// bg-gradient-to-b from-[#000000] to-[#E8BF21]
const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const actionConfiguration = useCompanyActionConfiguration();
  return (
    <CompanyActionThemeScope configuration={actionConfiguration}>
      <div className="flex min-h-screen flex-col overflow-hidden bg-[radial-gradient(circle_at_top,#f8f3e7_0%,#f4efe5_42%,#efe7da_100%)]">
        <ToastContainer />
        <JobPublicationApprovalPrompt />

        {/* Fixed Header */}
        <div className="fixed top-0 left-0 right-0 z-50 shadow-[0_18px_40px_rgba(0,0,0,0.28)]">
          <Header />
        </div>

        <div
          className="flex flex-1 overflow-hidden"
          style={{ paddingTop: '82px' }}
        >
          {/* Add padding-top to account for fixed header */}
          {/* Fixed Sidebar */}
          <div className="fixed bottom-0 left-0 top-[82px] z-40">
            {/* Position sidebar below header */}
            <Sidebar />
          </div>
          {/* Main Content */}
          <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
            <div className="min-h-0 flex-1 w-full overflow-hidden">
              <div className="w-full h-full">
                <RouteErrorBoundary>
                  <Outlet />
                </RouteErrorBoundary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CompanyActionThemeScope>
  );
};

export default SidebarLayout;
